import '../videoComponents/NextVid'
import '../videoComponents/PreviousVid'
import videojs from 'video.js'

/**
 * Sets up next and previous video buttons on video player
 * @param {Player} player
 * @param {Object} options
 */
const setupPlaylistNavButtons = (player, options) => {
  const firstEntry = () => {
    return options.playlistPos === 0
  }

  const lastEntry = () => {
    return options.playlistPos === options.listEntriesInformation.listLength()
  }

  if (options.enable) {
    if (!firstEntry()) {
      const PrevButton = videojs.getComponent('PreviousVid')
      let prevBtn = new PrevButton(player, {
        url: options.listEntriesInformation.getPrevEntryUrl(options.playlistPos)
      })
      prevBtn.contentEl().classList = 'vjs-prev-btn vjs-control'
      player.getChild('controlBar').addChild(prevBtn)
    }
    if (!lastEntry()) {
      const NextButton = videojs.getComponent('NextVid')
      let nextBtn = new NextButton(player, {
        url: options.listEntriesInformation.getNextEntryUrl(options.playlistPos)
      })
      nextBtn.contentEl().classList = 'vjs-next-btn vjs-control'
      player.getChild('controlBar').addChild(nextBtn)
    }
  }
}

export default setupPlaylistNavButtons
